import React from 'react';

import { ChatWidget } from './ChatWidget';
import type { IChatWidgetProps } from './types';

export function withChatWidget<TProps extends JSX.IntrinsicAttributes>(
  chatWidgetArgs?: Omit<IChatWidgetProps, 'domNodeRef'>,
) {
  return function (WrappedComponent: React.ComponentType<TProps>) {
    return ({ chatWidget, ...props }: TProps & { chatWidget?: IChatWidgetProps }) => (
      <>
        <WrappedComponent {...(props as TProps)} />
        <ChatWidget {...chatWidget} {...chatWidgetArgs} />
      </>
    );
  };
}
